<script setup>
/*
 * Indlejret indhold fra en tredjepart.
 *
 * INTET INDLÆSES FØR BRUGEREN HAR SAGT JA. Alle fem platforme saetter
 * tredjepartscookies og loader fremmed JavaScript, saa indtil samtykket
 * er givet staar der en plads med en knap. Det er ogsaa dét der holder
 * siden hurtig — en TikTok-indlejring er flere hundrede kilobyte.
 *
 * YouTube bruger nocookie-domaenet naar den foerst er sluppet igennem.
 */
import { computed, onMounted, ref } from 'vue';
import CookieService from '@/Services/CookieService';

const props = defineProps({ data: { type: Object, required: true } });

const maa = ref(false);
const tvunget = ref(false);

onMounted(() => {
    try {
        maa.value = CookieService.consentTo('marketing');
    } catch (e) {
        maa.value = false;
    }
});

const vis = computed(() => maa.value || tvunget.value);

const NAVNE = {
    youtube: 'YouTube',
    tiktok: 'TikTok',
    x: 'X',
    facebook_opslag: 'Facebook',
    facebook_side: 'Facebook',
};

const navn = computed(() => NAVNE[props.data.platform] || 'en tredjepart');

const ramme = computed(() => {
    const v = encodeURIComponent(props.data.vaerdi || '');
    switch (props.data.platform) {
        case 'youtube':
            return `https://www.youtube-nocookie.com/embed/${v}`;
        case 'facebook_opslag':
            return `https://www.facebook.com/plugins/post.php?href=${v}&show_text=true&width=500`;
        case 'facebook_side':
            return `https://www.facebook.com/plugins/page.php?href=${v}&tabs=timeline&width=500`;
        default:
            return null;
    }
});
</script>

<template>
    <p v-if="!data.platform || !data.vaerdi" class="text-secondary small mb-0">
        Indlejringen er ikke sat op.
    </p>

    <div v-else-if="!vis" class="samtykke">
        <p class="mb-2">
            Her ligger indhold fra <strong>{{ navn }}</strong>. Det sætter cookies hos dem,
            og vi henter det derfor ikke uden dit samtykke.
        </p>
        <button type="button" class="btn btn-sm btn-primary" @click="tvunget = true">
            Vis indhold fra {{ navn }}
        </button>
    </div>

    <div v-else class="indlejring">
        <div v-if="ramme" class="forhold">
            <iframe
                :src="ramme"
                :title="`Indhold fra ${navn}`"
                loading="lazy"
                allowfullscreen
                referrerpolicy="strict-origin-when-cross-origin"
            ></iframe>
        </div>

        <p v-else class="mb-0">
            <a :href="data.vaerdi" target="_blank" rel="noopener nofollow">Se opslaget på {{ navn }}</a>
        </p>
    </div>
</template>

<style scoped>
.samtykke { border: 1px dashed var(--pc-border); border-radius: var(--pc-radius); padding: 1rem 1.25rem; background: var(--pc-bg-tertiary); }
.forhold { position: relative; aspect-ratio: 16 / 9; }
.forhold iframe { position: absolute; inset: 0; width: 100%; height: 100%; border: 0; border-radius: var(--pc-radius); }
</style>
